<section *ngIf="tabData$ | async as tabData">
    <ng-container *ngFor="let table of tabData.tables">
        <ng-container [ngSwitch]="table.type">
            <ls-table *ngSwitchCase="'table'" [data]="table"></ls-table>
            <div *ngSwitchCase="'markup'" [innerHTML]="table.markup"></div>
        </ng-container>
    </ng-container>
    <linescale [lsData]="tabData.competitors_linescale"></linescale>
    <ls-table [data]="tabData.competitors_table"></ls-table>
    <mat-divider></mat-divider>
    <mat-divider></mat-divider>
    <h2>Diagnostics</h2>
    <div *ngFor="let diag of tabData.diagnostics">
        <linescale [lsData]="diag.linescale"></linescale>
        <ls-table [data]="diag.table"></ls-table>
        <mat-divider class="spacer"></mat-divider>
    </div>
</section>